import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from '@repo-manager/ui';

import { App } from './App';
import { SupabaseProvider } from './lib/supabase-context';
import './styles.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element in index.html');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <SupabaseProvider>
      <App />
      <Toaster />
    </SupabaseProvider>
  </React.StrictMode>,
);
